import { render } from "./Reporting.vue?vue&type=template&id=d057d4f8"
import script from "./Reporting.vue?vue&type=script&lang=js"
export * from "./Reporting.vue?vue&type=script&lang=js"

import "./Reporting.vue?vue&type=style&index=0&id=d057d4f8&lang=scss"

import exportComponent from "D:\\CTL-Project\\Mbf5_HCC\\XaQuangHa\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__